import styled, { css } from 'styled-components';

import { GRID } from 'constants/grids';

export const Container = styled.div`
  width: 100%;

  display: grid;
  align-items: center;
  overflow: hidden;
  grid-template-columns: ${GRID.SETTINGS};

  ${({ theme }) => css`
    padding: ${theme.padding.input};
    padding-right: ${theme.padding.default};
    column-gap: ${theme.padding.small};
    border-radius: ${theme.borderRadius.biggest};
    background-color: ${theme.colors.grey.main};
  `}
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;

  ${({ theme }) => css`
    gap: ${theme.padding.small};
  `}
`;
